module.exports = __webpack_public_path__ + "static/media/Auth0-webauthn-3.5dd49701.png";